
const digest = '414a5dd87b5a74932edc74127615a5d95d7497bd7b33c9266056bd669a8ba361';
const classes = {"wrapper":"_wrapper_18bpc_1","title":"_title_18bpc_10","label":"_label_18bpc_13"};
const css = `._wrapper_18bpc_1 {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #eaedf3;
  padding: 12px;
  font-family: Rubik, "sans-serif";
  font-size: 14px;
}
._wrapper_18bpc_1 ._title_18bpc_10 {
  font-weight: 600;
}
._wrapper_18bpc_1 ._label_18bpc_13 {
  color: #1d65d8;
  font-weight: 600;
  margin: 10px 0 5px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  